
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "createGuide",
      resolverType: "mutation",
      routePath: "/createGuide",
      httpMethod: "POST",
    });
  